import { memo } from 'react';
import logoIcon from 'assets/images/CashD-logo.svg';

// Define props interface
interface LogoIconProps {
  width?: number | string;
  alt?: string;
}

const LogoIcon = memo(({ width = 200, alt = 'CashD Logo' }: LogoIconProps) => {
  const logoSrc = logoIcon
  return (
    <img src={logoSrc} alt={alt} width={width} />
  );
});

export default LogoIcon;